<!-- Sidebar is now managed via SidebarViewService (pushed in ngOnInit, popped in ngOnDestroy) -->

<!-- Main content: NewChatComponent (/bob) or ActiveThreadComponent (/bob/thread) -->
<router-outlet></router-outlet>

<!-- Search Dialog -->
@if(searchDialogVisible) {
<app-dialog [visible]="searchDialogVisible" (closed)="closeSearchDialog()" [showCloseButton]="false"
    [fullscreenOnMobile]="true" class="max-w-[600px] !p-0">
    <ng-template #bodyTemplate>
        <app-command [placeholder]="'Search threads...'" [items]="searchCommandItems" [loading]="isSearchLoading"
            [emptyMessage]="'No threads found.'" [loadingMoreMessage]="'Loading more...'"
            [searchGroupLabel]="'Search Results'" [isFetchingMore]="searchThreadsQuery.isFetchingNextPage()"
            [searchValue]="searchValue" [showGroups]="true" (itemSelected)="onThreadSelected($event)"
            (searchValueChange)="onSearchValueChange($event)" (closeClicked)="closeSearchDialog()">
        </app-command>
    </ng-template>
</app-dialog>
}

<!-- Delete Thread Confirmation Dialog -->
@if(deleteThreadDialogVisible) {
<app-delete-confirmation [(visible)]="deleteThreadDialogVisible" headerText="Are you sure?"
    bodyText="This action will delete the thread" confirmButtonText="Proceed" (onConfirm)="deleteThread()">
</app-delete-confirmation>
}

<!-- Edit Thread Dialog -->
@if(editThreadDialogVisible()) {
<app-edit-thread [(visible)]="editThreadDialogVisible" [(threadTitle)]="threadTitleToEdit"
    (onSave)="updateThreadTitle()">
</app-edit-thread>
}

<!-- Manage Memories Dialog -->
@if(showManageMemoriesDialog()) {
<app-manage-memories [visible]="showManageMemoriesDialog()" (visibleChange)="showManageMemoriesDialog.set($event)">
</app-manage-memories>
}

<!-- Manage Skills Dialog -->
@if(skillsDialogVisible()) {
<app-manage-skills [visible]="skillsDialogVisible()" (visibleChange)="skillsDialogVisible.set($event)" />
}

<!-- Prompt Library Walkthrough -->
<app-prompt-library-walkthrough #walkthroughRef
    (gotIt)="onPromptLibraryWalkthroughGotIt()"
    (checkPrompts)="onPromptLibraryWalkthroughCheckPrompts()"
    (dismissed)="onPromptLibraryWalkthroughDismissed()">
</app-prompt-library-walkthrough>
